import { Injector } from '@angular/core'
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'
import { ErrorTailorConfig } from '@ngneat/error-tailor'
import { TranslateService } from '@ngx-translate/core'
import { ErrorMessageComponent } from '../../shared/components/error-message/error-message.component'

export const ERROR_TAILOR_CONFIG: ErrorTailorConfig = {
    errors: {
        useFactory(injector: Injector) {
            const service = injector.get(TranslateService)
            return {
                required: () => service.instant('validationMessages.required'),
                email: () => service.instant('validationMessages.invalidEmail'),
                pattern: () => service.instant('validationMessages.pattern'),
                invalidPhoneFormat: () => service.instant('validationMessages.invalidPhoneFormat'),
                invalidKrsFormat: () => service.instant('validationMessages.invalidKrsFormat'),
                maxAmount: (max) => service.instant('validationMessages.maxAmount', { max: max }),
                minlength: ({ requiredLength }) =>
                    service.instant('validationMessages.minlength', { '0': requiredLength }),
                maxlength: ({ requiredLength }) =>
                    service.instant('validationMessages.maxlength', { '0': requiredLength }),
                min: ({ min }) => service.instant('validationMessages.min', { '0': min }),
                max: ({ max }) => service.instant('validationMessages.max', { '0': max }),
                serverError: (errorMessage) => errorMessage,
                validationError: (errorMessage) => errorMessage,
                ngbDate: (error: any): string => {
                    if (error.invalid) {
                        return service.instant('validationMessages.invalidDateFormat')
                    }
                    if (error.maxDate) {
                        const maxDate: NgbDateStruct = error.maxDate.maxDate
                        const day = `${maxDate.day}`.padStart(2, '0')
                        const month = `${maxDate.month}`.padStart(2, '0')
                        const maxDateString = `${day}-${month}-${maxDate.year}`
                        return service.instant('validationMessages.maxDate', { maxDate: maxDateString })
                    }
                    if (error.minDate) {
                        const minDate: NgbDateStruct = error.minDate.minDate
                        const day = `${minDate.day}`.padStart(2, '0')
                        const month = `${minDate.month}`.padStart(2, '0')
                        const minDateString = `${day}-${month}-${minDate.year}`
                        return service.instant('validationMessages.minDate', { minDate: minDateString })
                    }
                    return ''
                }
            }
        },
        deps: [Injector]
    },
    controlErrorComponent: ErrorMessageComponent,
    blurPredicate: (element) => {
        return (
            element.tagName === 'INPUT' ||
            element.tagName === 'SELECT' ||
            element.tagName === 'TEXTAREA' ||
            element.tagName === 'NG-SELECT' ||
            element.tagName === 'APP-AMOUNT-INPUT'
        )
    }
}
